module.exports = __webpack_public_path__ + "img/class.261bdd62.jpg";